{
    "prince": {
        "key": "prince",
        "isDead": false,
        "position": {
            "x": 8,
            "y": 2,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "bow",
        "power": 30,
        "maxhealth": 60,
        "imageKey": "prince",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "level": 6,
        "title": "Prince",
        "subtitle": "Student"
    }
}